import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  GetAllMerchantConfig(paging, sorting, filtering) {
    return requestGet(apiPath.STORE_CONF_LIST.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_edcMapping: filtering.edcMapping,
      f_printingType: filtering.printingType,
      f_printingAddress: filtering.printingAddress,
      f_autoPrintStages: filtering.autoPrintStages,
      f_isAutoPrintReceipt: filtering.isAutoPrintReceipt,
      f_status: filtering.status
    })
  },
  CreateMerchantConfig(payload) {
    return requestPost(apiPath.CREATE_STORE_CONF.path, payload)
  },
  UpdateMerchantConfig(id, payload) {
    return requestPut(`${apiPath.UPDATE_CONF.path}/${id}`, payload)
  },
  GetOneMerchantConfig(id) {
    return requestGet(`${apiPath.GET_ONE_STORE_CONF.path}/${id}`)
  },
  DeleteMerchantConfig(id) {
    return requestDelete(`${apiPath.DELETE_STORE_CONF.path}/${id}`)
  }
}

export default api
